<template>
  <div class="box">
    <div class="title-container is-flex">
      <h4 class="title is-centered is-4 has-text-primary">
        Horas Extra
      </h4>
    </div>
    <BTable
      :data="overtimeWithIndex"
      :columns="columns"
    >
      <template slot-scope="props">
        <BTableColumn
          class="limit-150"
          field="Days"
          internal
        >
          <BField>
            <BInput
              name="days"
              placeholder="Días"
              type="number"
              min="0"
              max="15"
              :value="props.row.days"
              required
              @input="onInput(id, 'days', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="hoursType"
          internal
        >
          <BField>
            <BSelect
              name="hoursType"
              placeholder="Selecciona el tipo"
              :value="props.row.hoursType"
              class="is-fullwidth"
              :disabled="loading"
              :loading="loading"
              required
              @input="onInput(id, 'hoursType', $event)"
            >
              <option
                v-for="option in hourTypeCatalog"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </BSelect>
          </BField>
        </BTableColumn>
        <BTableColumn
          field="ovetime"
          internal
        >
          <BField>
            <BInput
              name="ovetime"
              placeholder="Horas Extra"
              type="number"
              min="0"
              :value="props.row.ovetime"
              required
              @input="onInput(id, 'ovetime', $event)"
            />
          </BField>
        </BTableColumn>
        <BTableColumn
          field="amount"
          internal
        >
          <BField>
            <BInput
              name="amount"
              placeholder="Selecciona el tipo"
              type="number"
              min="0"
              step="0.01"
              :value="props.row.amount"
              required
              @input="onInput(id, 'amount', $event)"
            />
          </BField>
        </BTableColumn>
      </template>
    </BTable>
  </div>
</template>

<script>
import { hourType as hourTypeCatalog } from '@machete/common-catalogs';

const normalizeCatalog = ({ key, value }) => ({ value: key, label: value });

export default {
  name: 'PayrollOvertime',
  props: {
    id: { type: Number, default: 0 },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hourTypeCatalog: hourTypeCatalog.map(normalizeCatalog),
      columns: [
        { field: 'Days', label: 'Días Con Horas Extra', centered: true },
        { field: 'hoursType', label: 'Tipo de Horas', centered: true },
        { field: 'ovetime', label: 'Horas extra.', centered: true },
        { field: 'amount', label: 'Importe pagado', centered: true },
      ],
    };
  },
  computed: {
    overtimeWithIndex() {
      return this.$store.state.payroll.percepts[this.id].overtime.map((percept, index) => ({
        ...percept,
        id: index,
      }));
    },
  },
  mounted() {
    this.$store.commit('payroll/addOvertime', { index: this.id });
  },
  methods: {
    onInput(id, name, value) {
      this.$store.commit('payroll/addOvertime', { index: this.id, name, value });
    },
  },
};
</script>

<style scoped>
.title.is-4 {
  margin-bottom: 0;
}

.header-label {
  padding-right: 0.25rem;
}

.add-button {
  margin-right: 1.5rem;
}

.button.add-percept {
  padding-left: 0.75em!important;
  padding-right: 0.75em!important;
}

.button.add-percept .icon {
  margin-left: calc(-0.375em - 1px)!important;
  margin-right: calc(-0.375em - 1px)!important;
  font-size: inherit!important;
}

.add-percept-label {
  padding-left: .5rem;
}

.title-container {
  width: 100%;
  align-items: center;
  padding-bottom: .3rem;
  justify-content: space-between;
}

.limit-150 {
  width: 150px;
}
</style>
